import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 65.8 58.3",
  style: {"enable-background":"new 0 0 65.8 58.3"},
  "xml:space": "preserve"
}
const _hoisted_2 = { transform: "translate(0 0)" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("rect", {
    id: "gas-icon-3-rect",
    width: "65.8",
    height: "58.3"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("clipPath", { id: "gas-icon-3-clip-path" }, [
  /*#__PURE__*/_createElementVNode("use", {
    "xlink:href": "#gas-icon-3-rect",
    style: {"overflow":"visible"}
  })
], -1)
const _hoisted_5 = {
  transform: "translate(0 0)",
  style: {"clip-path":"url(#gas-icon-3-clip-path)"}
}
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconGas3',
  props: {
  color: {
    type: String,
    default: '#DBDBDB',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("g", _hoisted_5, [
          _createElementVNode("path", {
            stroke: __props.color,
            style: {"fill":"none","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"},
            d: "M9.4,29.3v27.6h47V29.3"
          }, null, 8, _hoisted_6),
          _createElementVNode("path", {
            stroke: __props.color,
            style: {"fill":"none","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"},
            d: "M64.3,27.5l-31.4-26 l-31.4,26"
          }, null, 8, _hoisted_7),
          _createElementVNode("path", {
            fill: __props.color,
            d: "M43.8,35c-0.7,0-1.4,0.3-1.9,0.9c-0.3-0.6-0.9-0.9-1.6-0.9c-0.6,0-1.3,0.3-1.7,0.7\n              c0-0.3-0.3-0.6-0.7-0.6c0,0,0,0,0,0h-0.2c-0.4,0-0.7,0.2-0.7,0.6c0,0,0,0.1,0,0.1v5.1c0,0.4,0.2,0.7,0.6,0.7c0,0,0.1,0,0.1,0h0.3\n              c0.4,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1v-3.8c0.3-0.3,0.7-0.6,1.1-0.6c0.3,0,0.6,0.1,0.6,0.9v3.5c0,0.4,0.2,0.7,0.6,0.7\n              c0,0,0.1,0,0.1,0h0.3c0.4,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1v-3.8c0.3-0.3,0.7-0.5,1.1-0.6c0.4,0,0.6,0.2,0.6,0.7v3.6\n              c0,0.3,0.2,0.7,0.6,0.7c0,0,0.1,0,0.1,0h0.3c0.4,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1v-3.8C45.6,35.7,45,35,43.8,35"
          }, null, 8, _hoisted_8),
          _createElementVNode("path", {
            fill: __props.color,
            d: "M50,36.3h-1c0.1-0.1,0.2-0.1,0.3-0.2c0.7-0.3,1.2-1.1,1.3-1.9c0-0.9-0.6-1.6-1.5-1.6\n              c-0.1,0-0.2,0-0.2,0c-0.8-0.1-1.5,0.4-1.8,1.1c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.2,0.3,0.4,0.3l0.2,0c0.3,0.1,0.6,0,0.7-0.3\n              c0,0,0-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.3,0.1,0.3,0.3c0,0.3-0.3,0.5-0.8,0.8c-0.2,0.1-0.3,0.2-0.5,0.4\n              c-0.5,0.3-0.8,0.9-0.9,1.5v0.3c0,0.3,0.2,0.5,0.5,0.5c0,0,0.1,0,0.1,0H50c0.3,0,0.6-0.2,0.7-0.5c0,0,0,0,0-0.1v-0.2\n              C50.7,36.5,50.4,36.2,50,36.3C50,36.3,50,36.3,50,36.3"
          }, null, 8, _hoisted_9),
          _createElementVNode("path", {
            fill: __props.color,
            d: "M19.3,40.1h-0.7v-6.7c0-0.3-0.2-0.6-0.5-0.6c0,0-0.1,0-0.1,0h-0.2c-0.3,0-0.6,0.1-0.8,0.2\n              l-1.3,0.4c-0.4,0.1-0.5,0.3-0.5,0.8c0,0.2,0,0.3,0.2,0.5c0.1,0.1,0.3,0.1,0.5,0.1l1-0.1v5.5h-0.7c-0.3-0.1-0.7,0.2-0.7,0.5\n              c0,0.1,0,0.1,0,0.2V41c0,0.3,0.2,0.6,0.5,0.7c0.1,0,0.1,0,0.2,0h3.2c0.3,0.1,0.7-0.2,0.7-0.5c0-0.1,0-0.1,0-0.2v-0.2\n              c0-0.3-0.2-0.6-0.5-0.7C19.4,40.1,19.4,40.1,19.3,40.1"
          }, null, 8, _hoisted_10),
          _createElementVNode("path", {
            fill: __props.color,
            d: "M21.2,37.3 M27.5,37.3"
          }, null, 8, _hoisted_11),
          _createElementVNode("path", {
            fill: __props.color,
            d: "M31.2,32.7c-2,0-3.2,1.6-3.2,4.6c0,2.9,1.1,4.5,3.2,4.5s3.2-1.6,3.2-4.5\n              C34.4,34.3,33.2,32.7,31.2,32.7 M31.2,40.3c-0.9,0-1.3-1-1.3-3c0-2.1,0.4-3.1,1.3-3.1c0.9,0,1.3,1,1.3,3.1\n              C32.5,39.3,32.1,40.3,31.2,40.3"
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("path", {
          style: {"clip-path":"url(#SVGID_00000085210653631613163660000017145643760372933550_)"},
          fill: __props.color,
          d: "M24.3,35.5\n            c-0.6,0-1.1,0.1-1.6,0.5l0.1-1.7h3c0.5,0,0.7-0.1,0.7-0.7v-0.2c0-0.3-0.2-0.6-0.5-0.7c-0.1,0-0.1,0-0.2,0h-3.7\n            c-0.4,0-0.7,0.2-0.7,0.6c0,0,0,0.1,0,0.1l-0.3,3.5c0,0.3,0,0.7,0.5,0.8l0.4,0.1c0.4,0.1,0.6-0.1,0.9-0.3l0.1-0.1\n            c0.3-0.2,0.6-0.4,0.9-0.4c0.7,0,1.4,0.5,1.4,1.2c0,0.1,0,0.2,0,0.3c0.1,0.8-0.5,1.5-1.2,1.6c-0.1,0-0.2,0-0.3,0\n            c-0.5,0-0.9-0.2-1.2-0.5l0,0c-0.2-0.2-0.4-0.5-0.9-0.3l-0.4,0.2c-0.3,0.1-0.4,0.4-0.4,0.7c0,0.1,0.1,0.2,0.2,0.3\n            c0.7,0.9,1.7,1.3,2.8,1.2c1.7,0.1,3.2-1.1,3.3-2.8c0-0.1,0-0.3,0-0.4c0.2-1.5-0.9-2.8-2.4-3C24.6,35.5,24.5,35.5,24.3,35.5"
        }, null, 8, _hoisted_13)
      ])
    ])
  ]))
}
}

})